import type { SVGProps } from 'react';

const SvgNavigationRcs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="rcs" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M11.4 9.56c-1.52 0-2.76 1.24-2.76 2.76v7.36c0 1.52 1.24 2.76 2.76 2.76h9.19a2.76 2.76 0 0 0 2.76-2.76v-7.36c0-1.52-1.23-2.76-2.75-2.76zm3.68 4.14c0 .76-.62 1.38-1.38 1.38s-1.38-.62-1.38-1.38.62-1.38 1.38-1.38 1.38.62 1.38 1.38m4.87 1.82a2.77 2.77 0 0 0-3.71 0l-1.62 1.47c-1.03-.84-2.59-.8-3.58.1l-.56.51v2.08c0 .12.02.24.07.35l1.73-1.58c.33-.3.89-.3 1.22 0l1.14 1.02 2.84-2.58a.92.92 0 0 1 1.24 0l2.8 2.54v-2.48l-1.56-1.42Z"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M16 .67C7.53.67.67 7.53.67 16S7.53 31.33 16 31.33c2.35 0 4.55-.62 6.48-1.53h7.31v-7.31c.91-1.93 1.53-4.13 1.53-6.48C31.33 7.53 24.47.67 16 .67M3.74 16C3.74 9.23 9.23 3.74 16 3.74S28.26 9.23 28.26 16c0 1.92-.54 3.76-1.37 5.45l-.16.32v4.96h-4.96l-.32.16c-1.69.84-3.53 1.37-5.45 1.37-6.77 0-12.26-5.49-12.26-12.26"
    />
  </svg>
);

export default SvgNavigationRcs;
